module.exports = __webpack_public_path__ + "45b47f3e9c7d74b80f5c6e0a3c513b23.woff";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/OpenSans-Light-webfont.woff
// module id = 1149
// module chunks = 0